export default "__VITE_ASSET__Dn9SYf$O__$_?url__"